import { Segments, SpeakerAnnotation } from '@lib/transcript/types';
import { useMemo } from 'react';
import { useMediaData } from './mediaData';

export function useTranscript(libraryId?: string, mediaId?: string, cacheKey?: string) {
  const { data: segments, error: segmentsError } = useMediaData<Segments>(
    'transcript.json',
    libraryId,
    mediaId,
    cacheKey,
  );
  const { data: speakerAnnotations } = useMediaData<SpeakerAnnotation>(
    'speaker_annotation.json',
    libraryId,
    mediaId,
    cacheKey,
  );

  const data = useMemo(() => {
    if (!segments || segments?.version !== 2 || !speakerAnnotations) {
      return segments;
    }

    return {
      ...segments,
      segments: segments.segments.map((segment) => {
        const annotation = segment.speaker ? speakerAnnotations[segment.speaker] : undefined;
        return {
          ...segment,
          displaySpeaker: annotation?.name ?? segment.speaker ?? undefined,
        };
      }),
    };
  }, [segments, speakerAnnotations]);

  return { data, error: segmentsError };
}
